import { Navigate } from 'react-router-dom'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const token = localStorage.getItem('admin_token')

  if (!token) {
    return <Navigate to="/admin/login" replace />
  }

  // Optional: Check if token is expired
  try {
    const decoded = atob(token)
    const [timestamp] = decoded.split(':')
    const tokenAge = Date.now() - parseInt(timestamp)

    // Token expires after 24 hours
    if (tokenAge > 24 * 60 * 60 * 1000) {
      localStorage.removeItem('admin_token')
      return <Navigate to="/admin/login" replace />
    }
  } catch (error) {
    localStorage.removeItem('admin_token')
    return <Navigate to="/admin/login" replace />
  }

  return <>{children}</>
}
